import PropTypes from "prop-types";

import ActionPopOutOptionWithSubMenu from "@/view/ActionPopOutOptionWithSubMenu/ActionPopOutOptionWithSubMenu.js";

const propTypes = {
  actionName: PropTypes.string,
  activeSubMenu: PropTypes.string,
  eventProperties: PropTypes.object,
  icon: PropTypes.node,
  popOutContents: PropTypes.node,
  setActiveSubMenu: PropTypes.func,
  disabled: PropTypes.bool,
};

const PresentMobileAction = ({
  actionName,
  activeSubMenu,
  eventProperties,
  icon,
  popOutContents,
  setActiveSubMenu,
  disabled,
}) => {
  const qaSelector = actionName.toLowerCase();

  return (
    <ActionPopOutOptionWithSubMenu
      actionName={actionName}
      activeSubMenu={activeSubMenu}
      dataProps={{ "data-qa-selector": qaSelector }}
      eventProperties={eventProperties}
      icon={icon}
      popOutContents={popOutContents}
      setActiveSubMenu={setActiveSubMenu}
      disabled={disabled}
    />
  );
};

PresentMobileAction.propTypes = propTypes;

export default PresentMobileAction;
